import React from 'react'
import {
  Select as SemanticSelect,
  DropdownProps,
  DropdownOnSearchChangeData,
  SemanticWIDTHS
} from 'semantic-ui-react'
import { useField } from 'react-final-form'

import { useFieldError } from '../../../hooks/useFieldError'
import { FormField } from './styles'

export interface SelectOption {
  key: string | number
  value: string | number
  text: string
}

interface SelectProps {
  id?: string
  name: string
  label?: string
  required?: boolean
  disabled?: boolean
  width?: SemanticWIDTHS
  fluid?: boolean
  readOnly?: boolean
  loading?: boolean
  search?: boolean
  multiple?: boolean
  clearable?: boolean
  options: SelectOption[]
  selectOnBlur?: boolean
  uppercase?: boolean
  lowercase?: boolean
  noResultsMessage?: string

  onSearchChange?: (
    event: React.SyntheticEvent<HTMLElement, Event>,
    data: DropdownOnSearchChangeData
  ) => void

  onChange?: (
    event: React.SyntheticEvent<HTMLElement, Event>,
    data: DropdownProps
  ) => void

  onBlur?: (event: React.FocusEvent<HTMLElement>, data: DropdownProps) => void
}

export const Select: React.FC<SelectProps> = ({
  name,
  options,
  multiple,
  loading,
  search,
  onChange,
  noResultsMessage = 'Nenhum resultado encontrado',
  selectOnBlur = false,
  readOnly,
  id = name,
  ...rest
}) => {
  const { input, meta } = useField(name, {
    subscription: {
      value: true,
      touched: true,
      error: true,
      submitError: true
    }
  })

  const error = useFieldError({ input, meta })

  function handleChange(
    event: React.SyntheticEvent<HTMLElement, Event>,
    data: DropdownProps
  ) {
    input.onChange(data.value)
    onChange?.(event, data)
  }

  const value = multiple ? input.value || [] : input.value

  if (readOnly) {
    const text = options.find(opt => opt.value === value)?.text || ''

    return (
      <FormField control="input" name={name} value={text} readOnly {...rest} />
    )
  }

  return (
    <FormField
      {...rest}
      id={id}
      control={SemanticSelect}
      name={name}
      options={options}
      multiple={multiple}
      loading={loading}
      search={search}
      value={value}
      onChange={handleChange}
      onBlur={input.onBlur}
      onFocus={input.onFocus}
      error={!!error}
      noResultsMessage={noResultsMessage}
      selectOnBlur={selectOnBlur}
    />
  )
}
